import React from 'react';
import Tooltip from '@amzn/meridian/tooltip';
import AiSparkleIcon from './AiSparkleIcon';

export interface AiSuggestionBadgeProps {
  reasonDetail: string;
}

/**
 * Reusable indicator component that renders a sparkle/AI icon with a tooltip
 * showing the reason detail for an AI-suggested subcategory.
 * Designed to be used inline next to any subcategory dropdown (individual add or bulk upload).
 */
const AiSuggestionBadge: React.FC<AiSuggestionBadgeProps> = ({ reasonDetail }) => {
  return (
    <Tooltip position="top" title={reasonDetail}>
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        <AiSparkleIcon size={16} />
      </span>
    </Tooltip>
  );
};

export default AiSuggestionBadge;
